module.exports = __webpack_public_path__ + "lang/cs.json";


//////////////////
// WEBPACK FOOTER
// ./lang/cs.json
// module id = 113
// module chunks = 3